import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-wams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CompareDatesUtil } from "../../../../shared/utils/date-field-validator.utils";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsWamsConstants } from "./view-application-details-wams.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { DatePipe } from "@angular/common";
let ViewApplicationDetailsWamsComponent = class ViewApplicationDetailsWamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    shortDatePipe;
    appControllerService;
    changeDetectorRefs;
    routerParamsService;
    detailsForm;
    validationMessages = ViewApplicationDetailsWamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypeFormControlName = ViewApplicationDetailsWamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    descriptionFormControlName = ViewApplicationDetailsWamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    clientReferenceNumberFormControlName = ViewApplicationDetailsWamsConstants.CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicantTelecommunicationLicenseNumberFormControlName = ViewApplicationDetailsWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME;
    scopeOfWorkFormControlName = ViewApplicationDetailsWamsConstants.SCOPE_OF_WORK_FORM_CONTROL_NAME;
    estimatedConstructionCostFormControlName = ViewApplicationDetailsWamsConstants.ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME;
    applicationFeeFormControlName = ViewApplicationDetailsWamsConstants.APPLICATION_FEE_FORM_CONTROL_NAME;
    constructionPeriodInWeeksFormControlName = ViewApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_FORM_CONTROL_NAME;
    proposedStartDateFormControlName = ViewApplicationDetailsWamsConstants.PROPOSED_START_DATE_FORM_CONTROL_NAME;
    proposedEndDateFormControlName = ViewApplicationDetailsWamsConstants.PROPOSED_END_DATE_FORM_CONTROL_NAME;
    laneClosureIsRequiredFormControlName = ViewApplicationDetailsWamsConstants.LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME;
    laneClosureExtentFormControlName = ViewApplicationDetailsWamsConstants.LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME;
    constructionPeriodUnitsFormControlName = ViewApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME;
    electricalServicesFormControlName = ViewApplicationDetailsWamsConstants.ELECTRICAL_SERVICES_FORM_CONTROL_NAME;
    servicesFormControlName = ViewApplicationDetailsWamsConstants.SERVICES_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsWamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsWamsConstants.APPLICATION_TYPE_LABEL;
    clientReferenceNumberLabel = ViewApplicationDetailsWamsConstants.CLIENT_REFERENCE_NUMBER_LABEL;
    applicantTelecommunicationLicenseNumberLabel = ViewApplicationDetailsWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_LABEL;
    scopeOfWorkFormLabel = ViewApplicationDetailsWamsConstants.SCOPE_OF_WORK_LABEL;
    estimatedConstructionCostLabel = ViewApplicationDetailsWamsConstants.ESTIMATED_CONSTRUCTION_COST_LABEL;
    applicationFeeLabel = ViewApplicationDetailsWamsConstants.APPLICATION_FEE_LABEL;
    constructionPeriodInWeeksLabel = ViewApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_LABEL;
    proposedStartDateLabel = ViewApplicationDetailsWamsConstants.PROPOSED_START_DATE_LABEL;
    proposedEndDateLabel = ViewApplicationDetailsWamsConstants.PROPOSED_END_DATE_LABEL;
    laneClosureIsRequiredLabel = ViewApplicationDetailsWamsConstants.LANE_CLOSURE_IS_REQUIRED_LABEL;
    laneClosureExtentLabel = ViewApplicationDetailsWamsConstants.LANE_CLOSURE_EXTENT_LABEL;
    constructionPeriodUnitsLabel = ViewApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_UNITS_LABEL;
    servicesLabel = ViewApplicationDetailsWamsConstants.SERVICES_LABEL;
    servicesDropdownSettings = ViewApplicationDetailsWamsConstants.SERVICES_DROPDOWN_SETTINGS;
    electricalServicesLabel = ViewApplicationDetailsWamsConstants.ELECTRICAL_SERVICES_LABEL;
    applicationTypes = [];
    zones = [];
    yesNoOptions = [];
    laneClosureExtentOptions = [];
    electricalServicesOptions = [];
    constructionPeriodUnitsOptions = [
        { code: "Days", value: "Days" },
        { code: "Months", value: "Months" },
        { code: "Weeks", value: "Weeks" },
        { code: "Years", value: "Years" }
    ];
    servicesOptions = [];
    applicationTypeOptions = [];
    selectedApplicationSubscription;
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, shortDatePipe, appControllerService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.shortDatePipe = shortDatePipe;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    verifyProposedDates(formControlName) {
        // checks if the startDate is >= endDate
        CompareDatesUtil.verifyProposedDates(this.detailsForm, this.proposedStartDateFormControlName, this.proposedEndDateFormControlName, formControlName, this.appControllerService);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationViewService.moduleID} and (name eq 'LaneClosureExtent' or name eq 'ElectricalServices' or name eq 'ApplicationType' or name eq 'Services')`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService
            .getLookupsObservable(params)
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsWamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.laneClosureExtentOptions = [];
        this.electricalServicesOptions = [];
        this.applicationTypeOptions = [];
        this.servicesOptions = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "LaneClosureExtent") {
                    this.laneClosureExtentOptions.push(JSON.parse(item.content));
                }
                if (item.name === "ElectricalServices") {
                    this.electricalServicesOptions.push(JSON.parse(item.content));
                }
                if (item.name === "Services") {
                    this.servicesOptions.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    this.applicationTypeOptions.push(JSON.parse(item.content));
                }
            });
        }
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.changeDetectorRefs.detectChanges();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        this.detailsForm.reset();
        this.detailsForm.disable();
        if (application.description) {
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        }
        if (application.scopeOfWork) {
            this.detailsForm.get(this.scopeOfWorkFormControlName).setValue(application.scopeOfWork);
        }
        if (application.clientReferenceNumber) {
            this.detailsForm.get(this.clientReferenceNumberFormControlName).setValue(application.clientReferenceNumber);
        }
        if (application.licenceNumber) {
            this.detailsForm.get(this.applicantTelecommunicationLicenseNumberFormControlName).setValue(application.licenceNumber);
        }
        if (application.applicationFee) {
            this.detailsForm.get(this.applicationFeeFormControlName).setValue(application.applicationFee);
        }
        if (application.estimatedCost) {
            this.detailsForm.get(this.estimatedConstructionCostFormControlName).setValue(application.estimatedCost);
        }
        if (application.proposedStartDate) {
            this.detailsForm.get(this.proposedStartDateFormControlName).setValue(this.shortDatePipe.transform(application.proposedStartDate, "yyyy-MM-dd"));
        }
        if (application.proposedEndDate) {
            this.detailsForm.get(this.proposedEndDateFormControlName).setValue(this.shortDatePipe.transform(application.proposedEndDate, "yyyy-MM-dd"));
        }
        if (application.laneClosureRequired) {
            this.detailsForm.get(this.laneClosureIsRequiredFormControlName).setValue(application.laneClosureRequired);
        }
        if (application.laneClosureExtent) {
            this.detailsForm.get(this.laneClosureExtentFormControlName).setValue(application.laneClosureExtent);
        }
        if (application.constructionPeriod) {
            this.detailsForm.get(this.constructionPeriodInWeeksFormControlName).setValue(application.constructionPeriod);
        }
        if (application.electricalServices) {
            this.detailsForm.get(this.electricalServicesFormControlName).setValue(application.electricalServices);
        }
        this.applicationTypeOptions.forEach(item => {
            if (item.value === application.applicationType) {
                this.detailsForm.get(this.applicationTypeFormControlName).setValue(item.value);
            }
        });
        this.constructionPeriodUnitsOptions.forEach(item => {
            if (item.value === application.constructionPeriodUnits) {
                this.detailsForm.get(this.constructionPeriodUnitsFormControlName).setValue(item.value);
            }
        });
        this.electricalServicesOptions.forEach(item => {
            if (item.value === application.electricalServices) {
                this.detailsForm.get(this.electricalServicesFormControlName).setValue(item.value);
            }
        });
        const selectedServices = [];
        application.applicationServices.forEach(applicationService => {
            this.servicesOptions.forEach(serviceOption => {
                if (serviceOption.value === applicationService.service) {
                    selectedServices.push(serviceOption);
                }
            });
        });
        this.detailsForm.get(this.servicesFormControlName).setValue(selectedServices);
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: DatePipe },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsWamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-wams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsWamsComponent);
export { ViewApplicationDetailsWamsComponent };
